"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputDefaultProps = exports.InputPropTypes = exports.inputCss = exports.InputWrapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _cleave = _interopRequireDefault(require("cleave.js"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

var _QuestionMark = _interopRequireDefault(require("../../Icons/QuestionMark"));

var _animations = require("@staccx/animations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HelpBox = function HelpBox(_ref) {
  var onClick = _ref.onClick;
  return _react["default"].createElement(HelpButton, {
    onClick: onClick,
    type: "button"
  }, _react["default"].createElement(_QuestionMark["default"], null));
};

var Input = _react["default"].forwardRef(function (_ref2, ref) {
  var options = _ref2.options,
      onChange = _ref2.onChange,
      autoFocus = _ref2.autoFocus,
      className = _ref2.className,
      disabled = _ref2.disabled,
      id = _ref2.id,
      name = _ref2.name,
      onBlur = _ref2.onBlur,
      onFocus = _ref2.onFocus,
      onKeyDown = _ref2.onKeyDown,
      placeholder = _ref2.placeholder,
      type = _ref2.type,
      value = _ref2.value,
      label = _ref2.label,
      mask = _ref2.mask,
      variant = _ref2.variant,
      autoComplete = _ref2.autoComplete,
      helpText = _ref2.helpText,
      defaultValue = _ref2.defaultValue,
      otherProps = _objectWithoutProperties(_ref2, ["options", "onChange", "autoFocus", "className", "disabled", "id", "name", "onBlur", "onFocus", "onKeyDown", "placeholder", "type", "value", "label", "mask", "variant", "autoComplete", "helpText", "defaultValue"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showHelp = _useState2[0],
      setShowHelp = _useState2[1];

  var cleave = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(ref);

  var setRawValue = function setRawValue(rawValue) {
    if (!cleave.current) {
      console.warn("setRawValue not supported for non cleave inputs");
      return;
    }

    cleave.current.setRawValue(rawValue);
  };

  (0, _react.useEffect)(function () {
    if (options) {
      cleave.current = new _cleave["default"](inputRef.current, _objectSpread2({}, options, {
        onValueChanged: onChange
      }));
    }

    if (ref) {
      ref.current = inputRef.current;
    }

    if (defaultValue) {
      console.log("setting default value");
      setRawValue(defaultValue);
    }
  }, []);
  return _react["default"].createElement(InputWrapper, {
    className: className,
    variant: variant
  }, label && _react["default"].createElement(InputLabel, {
    variant: variant,
    htmlFor: id
  }, label, helpText && _react["default"].createElement(NoWrapSpan, null, "\xA0", _react["default"].createElement(HelpIcon, {
    onClick: function onClick() {
      return setShowHelp(!showHelp);
    }
  }))), helpText && _react["default"].createElement(HelpText, {
    isVisible: showHelp
  }, helpText), _react["default"].createElement(InputNoMask, _extends({
    autoFocus: autoFocus,
    value: value,
    disabled: disabled,
    id: id,
    name: name,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    variant: variant,
    type: type,
    ref: inputRef,
    defaultValue: defaultValue,
    autoComplete: autoComplete
  }, otherProps)));
});

Input.themeProps = {
  iconComponent: {
    name: "INPUT_HELP_ICON_COMPONENT",
    description: "Icon shown. Defaults to Caret",
    type: _themeContants.themePropTypes.component
  },
  icon: {
    name: "INPUT_HELP_ICON_STYLE",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "INPUT",
    description: "Input style",
    type: _themeContants.themePropTypes.style
  },
  wrapper: {
    name: "INPUT_WRAPPER",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  label: {
    name: "INPUT_LABEL",
    description: "Label style",
    type: _themeContants.themePropTypes.style
  },
  helpText: {
    name: "INPUT_HELPTEXT",
    description: "Helptext style",
    type: _themeContants.themePropTypes.style
  },
  helpButton: {
    name: "BUTTON_HELP",
    description: "Help button style",
    type: _themeContants.themePropTypes.style
  }
};

var IconComponent = function IconComponent(_ref3) {
  var props = _extends({}, _ref3);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: Input.themeProps.iconComponent.name,
    fallback: HelpBox
  }, props));
};

var HelpButton = _styledComponents["default"].button.withConfig({
  displayName: "Input__HelpButton",
  componentId: "sc-1tfv7em-0"
})(["-webkit-appearance:none;border:initial;padding:0;cursor:pointer;line-height:0;", ";"], (0, _theming.applyVariants)(Input.themeProps.helpButton));

var HelpIcon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "Input__HelpIcon",
  componentId: "sc-1tfv7em-1"
})(["", ";"], (0, _theming.applyVariants)(Input.themeProps.icon.name));

var NoWrapSpan = _styledComponents["default"].span.withConfig({
  displayName: "Input__NoWrapSpan",
  componentId: "sc-1tfv7em-2"
})(["white-space:nowrap;"]);

var HelpText = _styledComponents["default"].div.withConfig({
  displayName: "Input__HelpText",
  componentId: "sc-1tfv7em-3"
})(["display:", ";opacity:0;animation:", " 0.4s ease-out 1 forwards;", ";"], function (p) {
  return p.isVisible ? "block" : "none";
}, _animations.FadeIn, (0, _theming.applyVariants)(Input.themeProps.helpText));

var InputLabel = (0, _styledComponents["default"])(_Label["default"]).withConfig({
  displayName: "Input__InputLabel",
  componentId: "sc-1tfv7em-4"
})(["", ";"], (0, _theming.applyVariants)(Input.themeProps.label));

var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Input__InputWrapper",
  componentId: "sc-1tfv7em-5"
})(["display:block;margin-bottom:0;position:relative;", ";"], (0, _theming.applyVariants)(Input.themeProps.wrapper));

exports.InputWrapper = InputWrapper;
var inputCss = (0, _styledComponents.css)(["display:block;width:100%;min-height:", ";margin:0 auto;border:1px solid ", ";border-radius:", ";padding-left:", ";padding-right:", ";font-family:", ";font-size:", ";transition:border-color 0.2s ease-out;-webkit-appearance:none;appearance:none;-moz-appearance:textfield;&::-webkit-input-placeholder{color:", ";}&:-moz-placeholder{color:", ";}&::-moz-placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&:-webkit-autofill{background-color:", ";}&:hover,&:focus,&:active{outline:none;background-color:", ";}&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}", ";", ";"], _theming.targetSize.normal, _theming.color.line, _theming.borderRadius, _theming.spacing.small, _theming.spacing.small, _theming.fontFamily.body, _theming.font.input, _theming.color.line, _theming.color.line, _theming.color.line, _theming.color.line, _theming.color.bg, (0, _theming.color)("subtleHover"), function (p) {
  return p.additionalCSS || null;
}, (0, _theming.applyVariants)(Input.themeProps.input));
exports.inputCss = inputCss;

var InputNoMask = _styledComponents["default"].input.withConfig({
  displayName: "Input__InputNoMask",
  componentId: "sc-1tfv7em-6"
})(["", ";"], inputCss);

var InputPropTypes = {
  autoFocus: _propTypes["default"].bool,
  callback: _propTypes["default"].func,

  /**
   * Disabled prop
   * @export
   */
  disabled: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  style: _propTypes["default"].object,
  type: _propTypes["default"].oneOf(["text", "email", "number", "tel", "url", "search", "date"]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  helpText: _themeContants.commonPropTypes.children,
  mask: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].func, _propTypes["default"].bool, _propTypes["default"].shape({
    mask: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].func]),
    pipe: _propTypes["default"].func
  })])
};
exports.InputPropTypes = InputPropTypes;
Input.propTypes = InputPropTypes;
var InputDefaultProps = {
  autoFocus: null,
  callback: null,
  disabled: false,
  hidden: false,
  name: null,
  onBlur: null,
  onChange: null,
  onKeyDown: null,
  placeholder: null,
  style: null,
  type: "text",
  value: undefined,
  label: "",
  mask: null,
  helpText: ""
};
exports.InputDefaultProps = InputDefaultProps;
Input.defaultProps = InputDefaultProps;
/** @component */

var _default = Input;
exports["default"] = _default;